import { render, staticRenderFns } from "./DashHeader.vue?vue&type=template&id=5d7556fe"
import script from "./DashHeader.vue?vue&type=script&lang=js"
export * from "./DashHeader.vue?vue&type=script&lang=js"
import style0 from "./DashHeader.vue?vue&type=style&index=0&id=5d7556fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports